import { Navigate } from '@tanstack/react-router'
import type { ReactNode } from 'react'
import { useAdminAuth } from '~/entities/session/model/use-admin-auth'
import { useAuth } from '~/entities/session/model/use-auth'
import * as m from '~/paraglide/messages'
import { storageManager } from '~/shared/lib/storage-manager'

/** Renders its children for a signed-in business user (or an admin viewing a business). */
export function DashboardAuthGate({ children }: { children: ReactNode }) {
  const { isAuthenticated: isBusinessAuthenticated, isLoading: isBusinessLoading } = useAuth()
  const { isAuthenticated: isAdminAuthenticated, isLoading: isAdminLoading } = useAdminAuth()

  const isAdminViewing = storageManager.isAdmin() && storageManager.getAdminViewingBusinessId()

  const isLoading = isBusinessLoading || isAdminLoading
  const isAuthenticated = isBusinessAuthenticated || (isAdminAuthenticated && isAdminViewing)

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="text-center">
          <div className="inline-block border-4 border-current border-r-transparent border-solid rounded-full w-8 h-8 animate-spin motion-reduce:animate-[spin_1.5s_linear_infinite] align-[-0.125em]" />
          <p className="mt-2 text-muted-foreground text-sm">{m.loading()}</p>
        </div>
      </div>
    )
  }

  if (!isAuthenticated) {
    if (storageManager.isAdmin()) {
      return <Navigate to="/admin-login" search={{ reason: '' }} />
    }
    return <Navigate to="/login" search={{ email: '', reason: '' }} />
  }

  return <>{children}</>
}
